import { render, staticRenderFns } from "./NFTForm.vue?vue&type=template&id=c629cfd8&scoped=true&"
import script from "./NFTForm.vue?vue&type=script&lang=ts&"
export * from "./NFTForm.vue?vue&type=script&lang=ts&"
import style0 from "./NFTForm.vue?vue&type=style&index=0&id=c629cfd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c629cfd8",
  null
  
)

export default component.exports